(function() {
    'use strict';

    angular
        .module('claimsApp')
        .controller('ClaimShowFileController', ClaimShowFileController);

    ClaimShowFileController.$inject = ['$scope', '$uibModalInstance','id','$uibModal','GLOBAL_URL', 'authExpiredInterceptor'];

    function ClaimShowFileController ($scope, $uibModalInstance,  id ,$uibModal, GLOBAL_URL, authExpiredInterceptor) {
    	var claimShowFileCtrl = this;
    	claimShowFileCtrl.url= GLOBAL_URL+'ga/claims/view-file?txnId='+id;
    	console.log(claimShowFileCtrl.url);
    	claimShowFileCtrl.ok= ok;
    	claimShowFileCtrl.cancel= cancel;
    	claimShowFileCtrl.selected = {
    	  };

    	  function ok() {
    	    $uibModalInstance.close(claimShowFileCtrl.selected.item);
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    }
})();
